const seo = {
  title: "Vipul Tyagi | AI Engineer",
  description:
    "AI Engineer specializing in production agentic systems, RAG architectures, and LLM fine-tuning. Experience at Warmwind AG, Robert Bosch, and DFKI.",
  og: {
    title: "Vipul Tyagi | AI Engineer",
    type: "website",
    url: "https://vipul111196.github.io/",
  },
};

const greeting = {
  title: "Vipul Tyagi",
  logo_name: "VipulTyagi",
  nickname: "",
  subTitle:
    "AI Engineer | Building Production Agentic Systems | RAG & LLM Fine-Tuning",
  resumeLink:
    "https://drive.google.com/file/d/1yXfe0ExxTZVLgCt5xk3Jan6GvaTMBs_i/view",
  portfolio_repository: "https://github.com/Vipul111196",
  githubProfile: "https://github.com/Vipul111196",
};

const socialMediaLinks = [
  {
    name: "Github",
    link: "https://github.com/Vipul111196",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/vipultyagi111196/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Gmail",
    link: "mailto:vipulvinaytyagi11@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
];

const skills = {
  data: [
    {
      title: "Generative AI & LLMs",
      fileName: "DataScienceImg",
      skills: [
        "Designed production agentic architecture processing 10,000+ daily requests with self-correction and drift recovery.",
        "Built Adaptive RAG Framework improving faithfulness +12%, relevancy +14%, context recall +20%.",
        "Fine-tuned LLaMA2 (QLoRA) and vision-language models (LoRA SFT), achieving 98% accuracy on 30K+ predictions.",
        "Architected memory compression managing 10M+ tokens across multi-day agent sessions.",
      ],
      softwareSkills: [
        {
          skillName: "LangChain",
          fontAwesomeClassname: "simple-icons:langchain",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "Ollama",
          fontAwesomeClassname: "simple-icons:ollama",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "Neo4j",
          fontAwesomeClassname: "simple-icons:neo4j",
          style: {
            color: "#008CC1",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "devicon:javascript",
          style: {
            color: "#008CC1",
          },
        },
        {
          skillName: "HTML",
          fontAwesomeClassname: "vscode-icons:file-type-html",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "CSS",
          fontAwesomeClassname: "logos:css-3",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "Flask",
          fontAwesomeClassname: "skill-icons:flask-light",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
      ],
    },

    {
      title: "AI & Machine Learning",
      skills: [
        "Built and deployed ML models achieving 90% F1-score for industrial defect detection at Bosch.",
        "Developed Explainable AI dashboards with SHAP values for stakeholder decision-making.",
        "End-to-end MLOps: Docker, CI/CD, MLflow experiment tracking, Grafana monitoring.",
        "Deployed models on AWS EC2 with automated pipelines and production monitoring.",
      ],
      softwareSkills: [
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Keras",
          fontAwesomeClassname: "simple-icons:keras",
          style: {
            backgroundColor: "white",
            color: "#D00000",
          },
        },
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "logos-pytorch",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "Deeplearning",
          imageSrc: "deeplearning_ai_logo.png",
        },
        {
          skillName: "MLFlow",
          fontAwesomeClassname: "simple-icons:mlflow",
          style: {
            color: "#326CE5",
          },
        },
      ],
    },

    {
      title: "Cloud & Infrastructure",
      fileName: "CloudInfraImg",
      skills: [
        "Deployed AI services on AWS (EC2, S3) and GCP with Docker containerization and CI/CD pipelines.",
        "Built ETL pipelines processing data from AWS S3 into ChromaDB and Neo4j for retrieval systems.",
        "Implemented LLM caching layer achieving ~50% reduction in API spend for high-volume agent requests.",
        "Production monitoring with Grafana dashboards tracking prediction accuracy, token usage, and system health.",
      ],
      softwareSkills: [
        {
          skillName: "GCP",
          fontAwesomeClassname: "simple-icons:googlecloud",
          style: {
            color: "#4285F4",
          },
        },
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "FastAPI",
          fontAwesomeClassname: "simple-icons:fastapi",
          style: {
            color: "#009688",
          },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "GIT",
          fontAwesomeClassname: "material-icon-theme:git",
          style: {
            color: "#326CE5",
          },
        },
        {
          skillName: "Linux",
          fontAwesomeClassname: "skill-icons:linux-light",
          style: {
            color: "#326CE5",
          },
        },
      ],
    },
  ],
};

const testimonials = {
  title: "Testimonials",
  description: "Here's what people I've worked with have to say about me:",
  data: [
    {
      name: "Murat Can Kurtuluş",
      position: "Data Scientist at Robert Bosch GmbH",
      feedback:
        "I am pleased to recommend Vipul, a talented and driven junior professional. Working with Vipul, I witnessed his strong enthusiasm for learning, passion for research, and impressive adaptability to new technologies. <br /> Vipul quickly grasps complex concepts and applies them effectively. As an early adopter of emerging tools, he not only embrace change but encourage peers to explore innovative solutions. <br /> His commitment to continuous learning through independent research, collaborative projects, and professional development has led to valuable contributions and fresh perspectives. <br /> Additionally, Vipul collaborates well with teams, communicates effectively, and consistently delivers high-quality work. <br /> I am confident Vipul will excel and bring value to any organization. Please do not hesitate to contact me for further details.",
    },
    {
      name: "Stefan Gerd Fritsch",
      position: "Researcher & PhD Candidate at DFKI GmbH",
      feedback:
        "I had the pleasure of supervising Vipul Tyagi during his master's thesis and now have the chance to work with him in our Embedded Intelligence department at DFKI, where he currently is a student assistant. Vipul stands out for his excellent analytical skills and deep understanding of complex technology. <br /><br /> For his master's thesis, \"Leveraging Generative AI for Technical Literature: An Adaptive RAG-Framework,\" Vipul created and tested a modular Retrieval-Augmented Generation system. His innovative methods and skill in using advanced RAG techniques earned him top marks in both the written and oral parts of his thesis. <br /><br /> Vipul quickly learns and effectively uses new technologies, showing creativity and strong problem-solving skills. He is a very talented programmer, works independently and efficiently, always finding proactive solutions to new challenges. His excellent communication skills also help him explain complex technical ideas clearly. <br /><br /> Vipul's dedication and professional approach make him a valuable member of our team. I am confident that he will succeed in any challenging position he chooses to take on.",
    },
    {
      name: "Ruben Kapp",
      position: "AI-Enabler and Mechanical Engineer at Robert Bosch GmbH",
      feedback:
        "I highly recommend Vipul. His motivation and enthusiasm were evident from day one, and he quickly mastered complex topics with minimal supervision. His contributions significantly advanced our projects through targeted, effective solutions. In particular, his work in the context of GenAI and RAG architecture has been instrumental in propelling our initiatives forward. It was a pleasure working with him, and I am confident he will excel as he embarks on his professional career.",
    },
    {
      name: "Bo Zhou",
      position: "AI Scientist at DFKI GmbH",
      feedback:
        "Vipul's diligence, balance of planing and execution, and attention to details really impressed us. We always learn something from him at every meeting!",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Rheinland-Pfälzische Technische Universität Kaiserslautern",
      subtitle:
        "M.Sc. in Commercial Vehicle Technology (Specialization: Artificial Intelligence)",
      logo_path: "RPTU_Logo.png",
      alt_name: "RPTU Kaiserslautern",
      duration: "2021 - 2025",
      descriptions: [
        "GPA: 1.4 | Master's Thesis graded 1.0 (highest possible) on Adaptive RAG Frameworks at Robert Bosch & DFKI.",
        "Coursework: Machine Learning, Very Deep Learning, Embedded Intelligence, Enterprise Data Science, Autonomous Systems.",
      ],
      website_link: "https://rptu.de/",
    },
    {
      title: "Bharati Vidyapeeth's University, College of Engineering, Pune",
      subtitle: "B.Tech in Mechanical Engineering",
      logo_path: "BVP_Logo.png",
      alt_name: "BVDU Pune",
      duration: "2014 - 2018",
      descriptions: [
        "GPA: 1.1 | Achiever Award for excellent academic performance.",
      ],
      website_link: "https://www.bvuniversity.edu.in/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Machine Learning Specialization",
      subtitle: "- Andrew Ng",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/specialization/certificate/D5SNLNQ7NDAT",
      alt_name: "Stanford University",
      color_code: "#8C151599",
    },
    {
      title: "Deep Learning",
      subtitle: "- Andrew Ng",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/specialization/certificate/V8XGFPQJ76ZS",
      alt_name: "deeplearning.ai",
      color_code: "#00000099",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  // subtitle: "Work, Internship and Volunteership",
  description:
    "From building production agentic systems at Warmwind AG to deploying ML solutions at Robert Bosch and DFKI, my work focuses on shipping AI that works reliably at scale.",
  sections: [
    {
      title: "Work",
      work: true,
      experiences: [
        {
          title: "Founding AI Engineer",
          company: "Warmwind AG",
          company_url: "https://www.warmwind.ai/",
          logo_path: "21510_warmwind_logo-removebg-preview.png",
          duration: "May 2025 - Present",
          location: "Jena, Germany",
          description: [
            "Designed production agentic architecture that decomposes complex user tasks into multi-step workflows, executes step-by-step with reflection mechanisms, and auto-corrects drift. System processes 10,000+ agent requests daily.",
            "Architected memory compression system managing 10M+ tokens per agent across multi-day sessions, enabling indefinite agent operation without context window overflow.",
            "Fine-tuned vision-language model using LoRA SFT for screen coordinate prediction, achieving 98% accuracy with <8 pixel error across 30,000+ predictions, enabling autonomous GUI interaction.",
            "Implemented LLM caching layer for high-volume agent requests, achieving ~50% reduction in API spend and lower latency.",
            "Built self-correcting agent system with automated error recovery and knowledge storage (vector DB + structured logs), reducing repeat task failures by 80% across 500+ production tasks.",
            "Skills:",
            "Python, LangChain, LangGraph, LoRA, Transformers, ChromaDB, Docker, AWS, CI/CD",
          ],
          color: "#000000",
        },
        {
          title: "AI Engineer - Working Student",
          company: "DFKI GmbH",
          company_url: "https://www.dfki.de/",
          logo_path: "DFKI_Logo.png",
          duration: "Nov 2024 - Jun 2025",
          location: "Kaiserslautern, Germany",
          description: [
            "Built ontology-aware Graph-RAG pipeline extracting knowledge graphs from 10,000+ research unstructured documents using LLM-generated ontologies and SHACL validation.",
            "Combined graph traversal with vector search to retrieve highly contextual, citation-grounded results for research domains.",
            "Developed state-of-the-art genetic algorithm that evolved 1200+ prompts through iterative optimization, boosting AI agent task completion accuracy by 40% on internal benchmarks.",
            "Skills:",
            "Slurm(HPC), Linux, Python, Transformers, LangChain, LangGraph, Ollama, Neo4j, SHACL",
          ],
          color: "#000000",
        },
        {
          title: "AI Engineer - Master Thesis (Grade 1.0)",
          company: "Robert Bosch GmbH & DFKI GmbH",
          company_url: "https://www.bosch.de",
          logo_path: "Bosch_Logo.png",
          duration: "July 2024 - Dec 2024",
          location: "Stuttgart, Germany",
          description: [
            "Developed Adjustable RAG Framework, increasing faithfulness by 12%, answer relevancy by 14%, and context recall by 20%.",
            "Designed hybrid three-layer retrieval system integrating semantic search (embeddings), graph traversal (Neo4j), and keyword matching, significantly improving answer relevance and reducing hallucinations.",
            "Built full-stack industrial Q&A system enabling engineers to query 5,000+ technical documents with citation-grounded, LLM-verified responses. Deployed on internal infrastructure with REST API and web interface.",
            "Skills:",
            "Python, AWS, Azure OpenAI, LangChain, LangGraph, Ragas, Streamlit, Git, GitLab, Docker, GitHub Actions, Neo4j, ChromaDB",
          ],
          color: "#0879bf",
        },
        {
          title: "AI Engineer - Working Student",
          company: "Robert Bosch GmbH",
          company_url: "https://www.bosch.de",
          logo_path: "Bosch_Logo.png",
          duration: "Nov 2023 - April 2024",
          location: "Stuttgart, Germany",
          description: [
            "Developed multi-agent LLM chatbot system enabling 100+ engineers to query internal documentation, troubleshoot issues, and generate technical reports through conversational AI.",
            "Fine-tuned LLaMA2 using QLoRA and deployed as REST API on proprietary GPU cluster, reducing OpenAI dependency and cutting API costs by \u20AC75-100/day (\u20AC2,250-3,000/month sustained savings).",
            "Built deployment pipeline with Docker and CI/CD to AWS, and implemented Grafana monitoring dashboard tracking chatbot usage, token consumption.",
            "Skills:",
            "Python, AWS, Azure OpenAI, LangChain, LangGraph, Streamlit, Ollama, Git, FastAPI, GitLab, Docker, Transformers, Huggingface",
          ],
          color: "#9b1578",
        },
        {
          title: "Data Science Consultant - Intern",
          company: "Robert Bosch GmbH",
          company_url: "https://www.bosch.de",
          logo_path: "Bosch_Logo.png",
          duration: "May 2023 - Oct 2023",
          location: "Stuttgart, Germany",
          description: [
            "Led end-to-end ML project for diesel injector defect detection: built ETL pipeline (MongoDB), performed feature engineering, and trained classification model achieving 90% F1-score using CRISP-DM framework.",
            "Deployed ML model to AWS EC2 with Docker containerization and CI/CD pipeline. Built REST API and monitoring dashboard (Grafana) tracking prediction accuracy and system health in production.",
            "Developed Explainable AI dashboard using SHAP values to visualize model decisions and feature importance, enabling stakeholder validation and model debugging.",
            "Skills:",
            "Python, MongoDB, Airflow, Numpy, Pandas, Scikit-Learn, Keras, TensorFlow, Git, DVC, Docker, Grafana, AWS",
          ],
          color: "#fc1f20",
        },
        {
          title: "Student Assistant - Software Developer",
          company: "Fraunhofer ITWM",
          company_url: "https://www.itwm.fraunhofer.de/",
          logo_path: "Fraunhofer_Logo.png",
          duration: "April 2023 - Sept 2023",
          location: "Kaiserslautern, Germany",
          description: [
            "Optimized MATLAB 3D image preprocessing scripts by converting them into efficient C++ code, increasing processing speed by 6%.",
            "Contributed to software development and deployment by optimizing image processing and CI/CD pipelines in an agile team.",
            "Skills:",
            "C++, MATLAB, Git, GitLab, Docker, Jenkins, GCP",
          ],
          color: "#0879bf",
        },
        {
          title: "Manufacturing Methods Engineer",
          company: "Lucas TVS Ltd",
          company_url: "https://www.lucastvs.com/",
          logo_path: "Lucas_TVS_Logo.png",
          duration: "July 2018 - Sept 2020",
          location: "Pune, India",
          description: [
            "Led cross-functional team delivering automotive components from concept to production, managing client requirements and technical specifications.",
            "Used Data Analytics and Six Sigma to improve production efficiency.",
            "Skills:",
            "Client Communication, Data Analysis, Six Sigma, Team Leadership, Process Improvement",
          ],
          color: "#0879bf",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "Selected projects in Agentic AI, Knowledge Graphs, RAG systems, and end-to-end MLOps pipelines.",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "Vipul_portrait.jpg",
    description: [
      "Open to AI Engineer roles in Germany and Europe. \n Reach out via LinkedIn, GitHub, or email.",
    ],
  },
  addressSection: {
    title: "Address",
    subtitle: "Jena, Thuringia, Germany",
    country: "Germany",
    region: "Thuringia",
  },
  emailSection: {
    title: "Email:",
    subtitle: "vipulvinaytyagi11@gmail.com",
  },
};

export {
  seo,
  greeting,
  socialMediaLinks,
  skills,
  degrees,
  certifications,
  experience,
  projectsHeader,

  contactPageData,
  testimonials,
};
